import { Pipe, PipeTransform } from '@angular/core';
import { PermissionService } from '../permission/permission.service';

@Pipe({
  name: 'permission',
  standalone: false,
})
export class PermissionPipe implements PipeTransform {
  constructor(private perm: PermissionService) {}

  transform(name: string) {
    return this.perm.hasPermission(name);
  }
}
